<template>
  <div :class="{'d-flex justify-center align-center': !showButtonsVertically && display.smAndUp }">
    <div class="d-flex justify-center align-center height-auto mt-4">
      <div class="mr-4 d-flex">
        <img
          class="rounded-lg logo-size cursor-pointer"
          src="/login-options/appStore.png"
          eager
          @click="goToAppStoreDownload"
        >
      </div>
      <div class="d-flex">
        <img
          class="rounded-lg logo-size cursor-pointer"
          src="/login-options/googlePlayStore.png"
          eager
          @click="goToPlayStoreDownload"
        >
      </div>
    </div>
    <div :class="showButtonsVertically || display.xs ? 'd-flex justify-center align-center' : 'ml-4'">
      <div class="d-flex mt-4">
        <img
          class="rounded-lg logo-size cursor-pointer"
          src="/login-options/chromeStore.png"
          eager
          @click="goToChromeExtensionDownload"
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDisplay } from 'vuetify'
const display = ref(useDisplay())
defineProps({
  showButtonsVertically: { type: Boolean, default: false }
})
const { link: { appStore, playStore } } = useDeviceStore()
const goToPlayStoreDownload = () => window.open(playStore)
const goToAppStoreDownload = () => window.open(appStore)
const goToChromeExtensionDownload = () => window.open('https://chrome.google.com/webstore/detail/emissary-texting-for-recr/nnmfpbhfambhofjfeojpbbclepfgbine')
</script>
<style scoped>
.logo-size {
  height: 40px;
  width: 136px;
}
</style>
